import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase, UserService } from 'vnpost-shared';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { passwordPattern } from '../../../config/password.config';
import { ConfirmationService } from 'primeng/api';
import { UserTypeId } from '../../../config/enums';
import { UnitService } from '../../../core/services/unit-service';
import { CoreUserService } from '../../../core/services/core-user.service';

@Component({
  selector: 'app-llb-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class LlbAddComponent extends SecondPageEditBase implements OnInit {
  listUnit: { label: string; value: string }[] = [];
  listGender: { label: string; value: number }[] = [{label: "Nam", value: 1}, {label: "Nữ", value: 0}];
  listStatus: { label: string; value: number }[] = [{label: "Đang hoạt động", value: 1}, {label: "Dừng hoạt động", value: 0}];
  unitCode = this.currentUser?.unitCode;
  listEthnic: { label: string; value: string }[] = [
    { label: 'Kinh', value: '1' },
    { label: 'Khác', value: '2' },
  ];

  constructor(
    protected _userService: UserService,
    protected _injector: Injector,
    private _unitService: UnitService,
    private _coreUserService: CoreUserService,
    private _confirmationService: ConfirmationService
  ) {
    super(_userService, _injector);
    this.formGroup = new UntypedFormGroup({
      llbCode: new UntypedFormControl([Validators.required]),
      email: new UntypedFormControl('', [Validators.email]),
      displayName: new UntypedFormControl('', [Validators.required]),
      phoneNumber: new UntypedFormControl('', [Validators.required, Validators.pattern(/^0\d{8,11}$/)]),
      gender: new UntypedFormControl('', [Validators.required]),
      userName: new UntypedFormControl([Validators.required]),
      dateOfBirth: new UntypedFormControl('', [Validators.required]),
      ethnic: new UntypedFormControl(''),
      idNumber: new UntypedFormControl(''),
      nation: new UntypedFormControl(''),
      address: new UntypedFormControl(''),
      unitCode: new UntypedFormControl('', [Validators.required]),
      // passwordHash: new UntypedFormControl('', [Validators.required]), // , Validators.pattern(passwordPattern)
      // confirmPassword: new UntypedFormControl('', [Validators.required]),
      status: new UntypedFormControl(''),
    });
  }

  ngOnInit() {
  }

  getListUnit() {
    this._unitService.getTreeUnitByUnitCode(this.currentUser?.unitCode).then((rs) => {
      if (rs.success) {
        this.listUnit = rs?.data
          ?.map((r) => ({
            label: `- ${r.unitName} (${r.unitCode})`,
            value: r.unitCode,
          }));
      } else {
        this.listUnit = [];
      }
    });
  }

  onShowPopup() {
    this.validationSummary.resetErrorMessages();
    this.resetForm();
    if (this.listUnit.length == 0) {
      this.getListUnit();
    }
    this.onReset();
    this._coreUserService.generateLlbCode(this.unitCode).then(res => {
      this.itemDetail.llbCode = res.data;
    }, err => {
      this._notifierService.showError('Khởi tạo mã CTV thất bại');
    })

    this.itemDetail.id = 0;
    this.itemDetail.gender = 1;
    this.itemDetail.unitCode = this.currentUser.unitCode;
    this.itemDetail.status = 1;
    this.itemDetail.isSuperUser = false;
    this.itemDetail.typeId = UserTypeId.LLB;
  }

  onChangeUnitCode() {
    this._coreUserService.generateLlbCode(this.itemDetail.unitCode).then(res => {
      this.itemDetail.llbCode = res.data;
    }, err => {
      this._notifierService.showError('Khởi tạo mã CTV thất bại');
    })
  }

  async save() {
    this.submitting = true;

    if (this.itemDetail.passwordHash !== this.itemDetail.confirmPassword) {
      this.formGroup.controls['passwordHash'].setErrors({ 'nomatch': true });
      this.formGroup.setErrors({ 'invalid': true });
      this.showValidateMessage();
      return;
    }

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }

    this._coreUserService.checkLlbCodeBeforeCreate(this.itemDetail.llbCode, this.itemDetail.unitCode).then(res => {
      if (res.data) {
        this._confirmationService.confirm({
          message: 'Mã CTV đã tồn tại bạn có muốn tạo mã CTV mới không?',
          header: 'Xác nhận',
          icon: 'pi pi-info-circle',
          acceptIcon:"none",
          rejectIcon:"none",
          rejectButtonStyleClass:"p-button-text",
          accept: () => {
            this.itemDetail.llbCode = res.data;
            this.submitting = false;
          },
          reject: () => {
            
          },
          key: 'positionDialog'
        });
      }
      else {
        if (this.itemDetail['id']) {
          this.onUpdate();
        } else {
          this.onInsert();
        }
      }
    }, err => {
      this._notifierService.showError('Có lỗi xảy ra');
    })
    
    
  }

  onInsert() {
    this.itemDetail.userName = this.itemDetail.llbCode;
    this.itemDetail.passwordHash = '123456@Vnp';
    this.itemDetail.confirmPassword = '123456@Vnp';
    this._baseService.post(this.itemDetail)
      .then(response => {
        if (this.continueAdding) {
          this.resetForm();
          this.itemDetail.id = 0;
        } else {
          this.closePopupMethod(true);
        }
        this._notifierService.showInsertDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      }, error => {
        if (error.error.error === 'USERNAME_DUPLICATE') {
          this.formGroup.controls['userName'].setErrors({ 'duplicate': true });
          this.formGroup.setErrors({ 'invalid': true });
          this.validationSummary.showValidationSummary();

        } else if (error.error.error === 'EMAIL_DUPLICATE') {
          this.formGroup.controls['email'].setErrors({ 'duplicate': true });
          this.formGroup.setErrors({ 'invalid': true });
          this.validationSummary.showValidationSummary();

        } else {
          this._notifierService.showInsertDataFailed();
        }
        this.submitting = false;
      });
  }
}
